export default theme => ({
    autoWidth: {
        width: 'auto'
    },
    leftText: {
        color: "#456d8f",
        fontSize: "20px"
    },
    priceText: {
        color: "#435a7f",
        fontSize: "22px",
        fontWeight: "600"
    },
    installmentText: {
        color: "#7395af",
        fontSize: 17,
        fontStyle: "italic",

        "@media all and (min-width: 392px) and (max-width: 412px)": {
            fontSize: theme.spacing.unit * 2
        },

        "@media all and (max-width: 391px)": {
            fontSize: theme.spacing.unit * 2 - 1
        }
    },
})
